<template>
    <answers ref="answers"
             code_question_group="GQ01"
             danger_code="MCAL22"
             :disable_answers="disableAnswers"
    />
</template>

<script>
import {mapMutations, mapState} from 'vuex';
import answers from '../../../components/answers.vue';

export default {
    name: 'index',
    components: {
        answers
    },
    computed: {
        ...mapState('calculator', [
            'question_groups',
            'product'
        ]),
    },
    methods: {
        ...mapMutations('calculator', [
            'setBasicQuestionGroups'
        ]),
        disableAnswers(questions_index) {
            let question_groups = JSON.parse(JSON.stringify(this.question_groups));

            let question_group = question_groups[questions_index];

            const codes = ['QCAL007', 'QCAL008', 'QCAL009'];

            const questions_subcategories = question_group.questions.filter(q => codes.includes(q.code));

            if (questions_subcategories.length) {

                const response_true = questions_subcategories.find(q => q.answer);

                if (!!response_true) {
                    question_group.questions.map(q => {
                        if (q.code === response_true.code) {
                            q.disabled = false;
                        } else if (codes.includes(q.code)) {
                            q.disabled = true;
                            q.answer = false;
                        }
                    });
                } else {
                    question_group.questions.map(q => {
                        if (codes.includes(q.code)) {
                            q.disabled = false;
                        }
                    });
                }

                this.setBasicQuestionGroups(question_groups);
            }
        },
    }
};
</script>
